module.exports = __webpack_public_path__ + "img/lunbo2.0a67b996.jpg";